import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { fetchCostEstimateDetail } from '#/api/crmMgmt/costEstimate/fetchDetail';
import { ROUTES } from '#/config/routes';
import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import CostEstimateCommandBar from '#/modules/crmMgmt/costEstimate/components/CostEstimateCommandBar';
import CostEstimateLinesSection from '#/modules/crmMgmt/costEstimate/components/CostEstimateLinesSection';
import CostEstimateMainInfoCard from '#/modules/crmMgmt/costEstimate/components/CostEstimateMainInfoCard';
import { getCostEstimateApiErrorMessage } from '#/modules/crmMgmt/costEstimate/helper/apiError';
import PageShell from '#/modules/infra/layout/PageShell';
import { costEstimateDetailQueryKey } from '#/utils/queryKeys';

const CostEstimateDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: costEstimateDetailQueryKey(id),
    queryFn: () => fetchCostEstimateDetail(id),
    enabled: Boolean(id),
  });

  const detail = detailQuery.data?.data;
  const refetch = () => detailQuery.refetch();

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-5xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">成本試算詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.costEstimate}>返回列表</Link>
            </Button>
          </div>

          {detailQuery.isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {detailQuery.isError ? (
            <p className="text-sm text-destructive">
              {getCostEstimateApiErrorMessage(detailQuery.error, '載入成本試算失敗')}
            </p>
          ) : null}

          {detail ? (
            <>
              <CostEstimateMainInfoCard
                detail={detail}
                actions={(
                  <CostEstimateCommandBar
                    key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
                    detail={detail}
                    onRefetch={refetch}
                  />
                )}
              />
              <CostEstimateLinesSection detail={detail} />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default CostEstimateDetailPage;
